<script>
  import { currentExhibitions } from "./exhibitions";
</script>

<div class="home">
  <div class="splash">
    <div class="title">Jasmine Venes</div>
    <div class="subtitle">Textile Works</div>
  </div>

  <div class="shows-heading">Recent Exhibitions</div>
  <div class="shows">
    {#each currentExhibitions as show}
      <a class="show" href={show.url} target="_new">
        <div class="show-title">{show.title}</div>
        {#if show.image}
          <img class="show-image" src={show.image} alt={show.title} />
        {/if}
        <div class="show-info">
          {show.description} at {show.venue}, {show.location}
        </div>
        <div class="show-dates">{show.dates}</div>
        {#if show.address}
          <div class="show-address">{show.address}</div>
        {/if}
      </a>
    {/each}
  </div>

  <div class="footer-space" />
</div>

<style>
  .home {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 2rem 8rem 2rem;
  }

  .splash {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4rem 0;
    gap: 1rem;
    color: #1a1a1a;
    width: 100%;
    max-width: 44rem;
    border-bottom: 1px solid var(--hairline);
    margin-bottom: 3rem;
  }
  .splash .title {
    font-family: "Cormorant Garamond", serif;
    font-weight: 400;
    font-size: 4.5rem;
    line-height: 1;
    text-align: center;
  }
  .splash .subtitle {
    font-size: 1.1rem;
    color: #555;
  }

  .shows-heading {
    font-family: "Cormorant Garamond", serif;
    font-style: italic;
    font-size: 1.25rem;
    color: #999;
    text-align: center;
  }

  /* Side-by-side shows share row tracks via subgrid, so the title, image,
     info, and dates rows stay aligned regardless of title line count. */
  .shows {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    row-gap: 1.2rem;
    width: 100%;
    max-width: 88rem;
  }

  .show {
    display: grid;
    grid-template-rows: subgrid;
    grid-row: span 4;
    justify-items: center;
    align-items: center;
    justify-self: center;
    padding: 3.5rem 2rem;
    width: 100%;
    max-width: 44rem;
    box-sizing: border-box;
    color: #666;
    text-align: center;
    text-decoration: none;
  }

  @media (min-width: 801px) {
    .shows .show .show-image {
      max-height: 28rem;
    }
  }
  .show .show-title {
    font-family: "Cormorant Garamond", serif;
    font-style: italic;
    font-size: 3.5rem;
    line-height: 1;
    color: var(--accent);
  }
  .show .show-image {
    max-width: 100%;
    max-height: 34rem;
    margin: 0.8rem 0;
    border: 1px solid var(--hairline);
    box-sizing: border-box;
  }
  .show .show-info {
    font-size: 1rem;
  }
  .show .show-dates {
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #333;
  }
  .show .show-address {
    font-size: 0.85rem;
    color: #999;
  }

  .footer-space {
    margin-top: 2rem;
    padding: 2.5rem 0 0 0;
    width: 100%;
    max-width: 44rem;
  }

  @media (max-width: 800px) {
    .home {
      padding: 0 1.5rem 5rem 1.5rem;
    }
    .splash {
      padding: 2.5rem 0;
      gap: 0.6rem;
    }
    .splash .title {
      font-size: 2.8rem;
    }
    .splash .subtitle {
      font-size: 1.15rem;
    }
    .shows {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .show {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.2rem;
      padding: 2.5rem 0.5rem;
      max-width: 100%;
    }
    .show .show-title {
      font-size: 2.4rem;
    }
  }
</style>
